import {
  Autocomplete,
  AutocompleteItem,
  AutocompleteProps,
} from "@heroui/react";
import { UseFormRegisterReturn } from "react-hook-form";
import { useAppSelector } from "@/hooks/useAppSelector.ts";
import { OfficeType } from "@/api/officeTypes";

export function NewOfficeTypeHandbook(props: AutocompleteProps<OfficeType>) {
  const items = useAppSelector((state) => state.handbooks.officeType);

  return (
    <Autocomplete
      defaultItems={items}
      label="Тип офиса"
      placeholder="Выберите тип офиса"
      variant="bordered"
      {...props}
    >
      {(item) => (
        <AutocompleteItem key={String(item.id)}>
          {item.display_name}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}

export function OfficeTypeHandbook({
  register,
  isInvalid,
  errorMessage,
  defaultSelectedKey,
}: {
  register: UseFormRegisterReturn;
  isInvalid: boolean;
  errorMessage: string;
  defaultSelectedKey?: string;
}) {
  const items = useAppSelector((state) => state.handbooks.officeType);

  return (
    <Autocomplete
      {...register}
      defaultItems={items}
      label="Тип офиса"
      placeholder="Выберите тип офиса"
      variant="bordered"
      isInvalid={isInvalid}
      errorMessage={errorMessage}
      defaultSelectedKey={defaultSelectedKey}
    >
      {(item) => (
        <AutocompleteItem
          key={String(item.id)}
        >{`${item.display_name}`}</AutocompleteItem>
      )}
    </Autocomplete>
  );
}
